import { useRef } from "react";
import { useTranslation } from "react-i18next";
import defaultContent from "../../../content/profile";
import { useAppDispatch, useAppSelector } from "../../../store";
import { hideProfile } from "../../../reducers/profile";
import { closeProfileClickTrack } from "../../../common/tealium/ABOProfile/Profile/IndexTrack";
import { TimeStamp } from "../../../common/components/TimeStamp/TimeStamp";
import LeafPanel from "../../../common/leaf/LeafPanel/LeafPanel";
import ABOProfileBody from "./ABOProfileBody/ABOProfileBody";
import ABOBusinessKPIBody from "./ABOBusinessKPIBody/ABOBusinessKPIBody";
import "./ABOProfileSlider.scss";

export type Props = {
  showOnlyPerformanceHistory: boolean;
  previousElement?: HTMLElement;
};

const ABOProfileSlider = (props: Props) => {
  const { previousElement, showOnlyPerformanceHistory } = props;
  const { t } = useTranslation(["profile"]);
  const isShowProfile = useAppSelector((state) => state.profile.isShowProfile);
  const profileType = useAppSelector((state) => state.profile.profileType);
  const isEnabled = useAppSelector((state) => state.boot?.configuration?.profile?.enableDownlineProfile ?? false);
  const dispatch = useAppDispatch();
  const contentRef = useRef<HTMLDivElement>(null);

  const closeProfile = () => {
    dispatch(hideProfile());
    closeProfileClickTrack();
  };

  const profileParam = new URLSearchParams(window.location.search).get("profile");
  const isLegacyOverride = profileParam === "legacy";
  const useDownlineProfile = (isEnabled || profileParam === "downline") && !isLegacyOverride;

  const showSlider = isShowProfile && profileType === "abo" && !useDownlineProfile;

  // Focus is handled by LeafPanel's close button focus on open.
  // We no longer focus contentRef here to avoid racing with LeafPanel.

  return (
    <LeafPanel
      title={
        showOnlyPerformanceHistory
          ? `${t(
              "aboProfile.aboProfilePerfHistory.title",
              defaultContent["aboProfile"]["aboProfilePerfHistory"]["title"],
            )}`
          : `${t("aboProfile.title", defaultContent["aboProfile"]["title"])}`
      }
      show={showSlider}
      onCloseClick={closeProfile}
      id={"abo-profile-slider"}
      previousElement={previousElement}
      applyScroll={true}
    >
      <div className="abo-profile-slider">
        <div ref={contentRef} tabIndex={-1}>
          {showOnlyPerformanceHistory ? (
            <ABOBusinessKPIBody isShowProfile={showSlider} />
          ) : (
            <ABOProfileBody isShowProfile={showSlider} />
          )}
        </div>
        <div className="abo-profile-slider__timestamp abo-profile-slider__timestamp--desktop">
          <TimeStamp dateFormat={"bigEndian"} />
        </div>
        <div className="abo-profile-slider__timestamp abo-profile-slider__timestamp--mobile">
          <TimeStamp dateFormat={"bigEndian"} />
        </div>
      </div>
    </LeafPanel>
  );
};

export default ABOProfileSlider;
